export enum CampaignIDs {
  CanstarBlue = '388',
  Oly = '400',
  OneBigSwitch = '100',
  SwitchYourMates = '987',
}

export enum ProductIDs {
  SwitchSaver = '13',
  PowerHouse = '14',
  PowerBusiness = '16',
  PowerOffset = '17',
  PowerDrive = '20',
  PowerDriveDay = '26',
  GasPowerHouse = '29N',
  GasPowerOffset = '28',
  EVDaySaver = '26S',
  EVNightSaver = '20S',
}

export const PromoIDs = {
  EVDay: 'evday-digital',
  EVNight: 'evnight-digital',
  EVDaySaver: 'evdaysaver-digital100-0225',
  EVNightSaver: 'evnightsaver-digital100',
  GasPowerHouse: 'power-house-gas50-digital-0525',
  GasPowerOffset: 'power-offset-gas-digital',
  PowerBusiness: 'powerbus-digital',
  PowerHouse: 'powerhouse0525elec-digital',
  PowerOffset: 'poweroffset-digital',
  SwitchSaver: 'SWSdigital200',
} as const;

export type PromoIDValues = (typeof PromoIDs)[keyof typeof PromoIDs];

export const DefaultPlanIDMapping: Record<ProductIDs, PromoIDValues> = {
  [ProductIDs.SwitchSaver]: PromoIDs.SwitchSaver,
  [ProductIDs.PowerHouse]: PromoIDs.PowerHouse,
  [ProductIDs.PowerBusiness]: PromoIDs.PowerBusiness,
  [ProductIDs.PowerOffset]: PromoIDs.PowerOffset,
  [ProductIDs.PowerDrive]: PromoIDs.EVNight,
  [ProductIDs.PowerDriveDay]: PromoIDs.EVDay,
  [ProductIDs.EVDaySaver]: PromoIDs.EVDaySaver,
  [ProductIDs.EVNightSaver]: PromoIDs.EVNightSaver,
  [ProductIDs.GasPowerHouse]: PromoIDs.GasPowerHouse,
  [ProductIDs.GasPowerOffset]: PromoIDs.GasPowerOffset,
};

export enum PlanFlow {
  Electricity = 'electricity',
  Gas = 'gas',
  DualFuel = 'dual_fuel',
  NoSelection = 'no_selection'
}
